var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectedBenchMarking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_2074_124405)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.6204 15.2012H0.379597C0.170819 15.2012 0 15.3809 0 15.6006C0 15.8202 0.170819 16 0.379597 16H15.6185C15.8273 16 15.9981 15.8202 15.9981 15.6006C15.9981 15.3809 15.8273 15.2012 15.6185 15.2012H15.6204Z",
    fill: "#1AD393"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.4783 7.875H11.2045C10.7852 7.875 10.4453 8.23264 10.4453 8.6738V13.2769C10.4453 13.7181 10.7852 14.0757 11.2045 14.0757H13.4783C13.8976 14.0757 14.2375 13.7181 14.2375 13.2769V8.6738C14.2375 8.23264 13.8976 7.875 13.4783 7.875Z",
    fill: "#1AD393"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16 6.19271C16 6.41238 15.8292 6.59211 15.6204 6.59211H10.0043V13.2781C10.0043 13.7194 9.66453 14.0769 9.24508 14.0769H6.97129C6.55184 14.0769 6.2121 13.7194 6.2121 13.2781V6.59211H5.86287V13.2781C5.86287 13.7194 5.52313 14.0769 5.10368 14.0769H2.82989C2.41044 14.0769 2.0707 13.7194 2.0707 13.2781V6.59211H0.379597C0.170818 6.59211 0 6.41238 0 6.19271C0 5.97304 0.170818 5.79331 0.379597 5.79331H2.0707V0.798802C2.0707 0.359461 2.41044 0.001997 2.82989 0H5.10368C5.52313 0.001997 5.86287 0.359461 5.86287 0.798802V5.79331H6.2121V3.70444C6.2121 3.2631 6.55184 2.90564 6.97129 2.90564H9.24508C9.66453 2.90564 10.0043 3.2631 10.0043 3.70444V5.79331H15.6204C15.8292 5.79331 16 5.97304 16 6.19271Z",
    fill: "#1AD393"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2074_124405"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedBenchMarking);
export default __webpack_public_path__ + "static/media/SelectedBenchMarking.f1feeb84f85d3d3dd280bd8cfbf5ec46.svg";
export { ForwardRef as ReactComponent };